@if (!hasSubmitted) {
    <div
        class="relative grow overflow-y-auto"
        [ngClass]="{'blur-[2px] pointer-events-none [&_*]:select-none': (loading$ | async) && hasSubmitted}">

        @if ((loading$ | async) && hasSubmitted) {
            <div class="absolute flex left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 justify-center items-center z-50">
                <mat-spinner [diameter]="32"></mat-spinner>
            </div>
        }
        <div
            class="flex flex-col gap-4 bg-valamargray border-2 static p-4"
            [ngClass]="((loading$ | async) && hasSubmitted) ? 'blur-[2px] pointer-events-none [&_*]:select-none' : ''"
        >
            <div class="flex gap-4 justify-end items-center select-none">
                <button class="valben-button text-lg" (click)="back()">Natrag</button>
            </div>
        </div>
    </div>
    <div class="flex text-lg m-4 justify-center">
        Nema podnesenih prijava.
    </div>
}
@if (hasSubmitted) {
    <div class="flex flex-wrap gap-2 mb-4 px-4 pt-4">
        @for (app of items; track app.masterId) {
        <button
            class="valben-button text-base"
            [ngClass]="selectedApplication?.masterId === app.masterId ? 'valben-button--selected' : 'valben-button--quiet'"
            (click)="selectApplication(app)"
        >
            {{ app.name }} {{ app.surname }} ({{ app.mbrad }})
        </button>
        }
    </div>

    <div
        class="relative grow overflow-y-auto"
        [ngClass]="{'blur-[2px] pointer-events-none [&_*]:select-none': loading$ | async}">

        @if (loading$ | async) {
            <div class="absolute flex left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 justify-center items-center z-50">
                <mat-spinner [diameter]="32"></mat-spinner>
            </div>
        }
        <div
            class="flex flex-col gap-4 bg-valamargray border-2 static p-4"
            [ngClass]="(loading$ | async) ? 'blur-[2px] pointer-events-none [&_*]:select-none' : ''"
        >
            <div class="flex gap-4 justify-end items-center select-none">
                <button class="valben-button text-lg" (click)="next()">Sljedeći</button>
                <button class="valben-button text-lg" (click)="back()">Natrag</button>
            </div>
            <valben-text-input
                [key]="modifyKngKeys.Name"
                [itemObservable]="editItemObservable"
                [update]="updateEditName"
                title="Ime"
                [error]="errors[modifyKngKeys.Name]"
                [preview]="true"
            ></valben-text-input>
            <valben-text-input
                [key]="modifyKngKeys.Surname"
                [itemObservable]="editItemObservable"
                [update]="updateEditSurname"
                title="Prezime"
                [error]="errors[modifyKngKeys.Surname]"
                [preview]="true"
            ></valben-text-input>
            <valben-text-input
                [key]="modifyKngKeys.OIB"
                [itemObservable]="editItemObservable"
                [update]="updateEditOib"
                title="OIB"
                [error]="errors[modifyKngKeys.OIB]"
                [preview]="true"
            ></valben-text-input>
            <valben-text-input
                [key]="modifyKngKeys.PhoneNumber"
                [itemObservable]="editItemObservable"
                [update]="updateEditPhoneNumber"
                title="Broj telefona"
                [error]="errors[modifyKngKeys.PhoneNumber]"
                [preview]="true"
            ></valben-text-input>
            <valben-text-input
                [key]="modifyKngKeys.Email"
                [itemObservable]="editItemObservable"
                [update]="updateEditEmail"
                title="E-mail"
                [error]="errors[modifyKngKeys.Email]"
                [preview]="true"
            ></valben-text-input>
            <valben-number-input
                [key]="modifyKngKeys.EmployeeMonthlyIncome"
                [itemObservable]="editItemObservable"
                [update]="updateEditEmployeeMonthlyIncome"
                title="Mjesečni prihod djelatnika"
                [error]="errors[modifyKngKeys.EmployeeMonthlyIncome]"
            ></valben-number-input>
            @if (numberOfFamilyMembers > 0) {
                <div class="space-y-6">
                    @for (i of familyMemberIndexes; track i) {
                    <div
                        class="border border-gray-900/10 rounded-md p-4">
                        <div class="font-semibold text-lg mb-3">Ukućan {{ i + 1 }}</div>
                        <valben-adult-family-member
                            [index]="i"
                            [itemObservable]="editItemObservable"
                            [update]="updateEditAdultFamilyMember"
                            [showMonthlyIncome]="true"
                            [error]="errors[modifyKngKeys.AdultFamilyMembers]"
                        ></valben-adult-family-member>
                    </div>
                    }
                </div>
            }
            <valben-superior-picker
                [employeeId]="currentEmployeeId"
                [superiorMaps]="superiorMaps"
                [update]="updateSuperior"
                [setHasExistingMap]="setHasExistingMap"
            ></valben-superior-picker>
            @if (currentPosition) {
                <div
                    class="px-10 py-4 border-2 border-gray-900/10 rounded-md">
                    <p class="text-lg font-semibold my-1">Ocijeni poziciju</p>
                    <div class="flex items-center gap-4">
                        <p>{{ currentPosition.name }}</p>
                        <mat-button-toggle-group hideSingleSelectionIndicator [value]="currentPosition.score">
                            @for (score of positionScores; track score) {
                                <mat-button-toggle
                                    [value]="score"
                                    class="text-valamarblueprimary"
                                    (click)="togglePositionScore(score)">
                                    {{ score }}
                                </mat-button-toggle>
                            }
                        </mat-button-toggle-group>
                    </div>
                </div>
            }
            <div class="flex gap-4 justify-end items-center select-none">
                <button class="valben-button text-lg" (click)="submit()">Spremno za procjenu nadređenog</button>
                <button class="valben-button text-lg" (click)="next()">Sljedeći</button>
                <button class="valben-button text-lg" (click)="back()">Natrag</button>
            </div>
        </div>
    </div>
}
